module.exports = __webpack_public_path__ + "img/pic_none.ac21aa25.png";